<template>
    <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;">

      <div class="input-part">
        <div class="input-label">
          <span tkey="有效期">{{i18n.tkey("lang_expiration")}}:</span>
        </div>

        <div style="display: flex;align-items: center;">
          <el-text>
            {{editObj.PromoStartDate}}
          </el-text>
            <span> - </span>
          <el-text>
            {{editObj.PromoEndDate}}
          </el-text>

        </div>
      </div>


      <div class="input-part">
        <div class="input-label">
          <span v-if="editObj.PromoStatus==1" tkey="優惠金額">{{i18n.tkey("lang_coupons_amount")}}:{{shopCompany.currcode}}</span>
          <span v-if="editObj.PromoStatus==2" tkey="優惠折扣">{{i18n.tkey("lang_coupons_discount")}}%：</span>
        </div>

        <div>
          <el-text v-if="editObj.PromoStatus==1">
            {{editObj.PromoCost}}
          </el-text>
          <el-text v-if="editObj.PromoStatus==2">
            {{editObj.PromoDiscount}}
          </el-text>
        </div>
      </div>
      <div class="input-part">
        <div class="input-label">
          <span tkey="數量">{{i18n.tkey("lang_qty")}}:({{i18n.tkey("lang_Nofilling_Norestrictions")}})</span>
        </div>

        <div>
          <el-text >
            {{editObj.PromoQty}}
          </el-text>

        </div>
      </div>
      <div class="input-part">
        <div class="input-label">
          <span tkey="使用數量">{{i18n.tkey("lang_Quantity_used")}}:</span>
        </div>

        <div>
          <el-text >
            {{editObj.RequestQty}}
          </el-text>

        </div>
      </div>
      <div class="input-part">
        <div class="input-label">
          <span tkey="優惠編碼">{{i18n.tkey("lang_Promo_Number")}}:</span>
        </div>

        <div>
          <el-text >
            {{editObj.PromoNo}}
          </el-text>

        </div>
      </div>

      <div >
        <div class="input-label">
          <span tkey="二維">{{i18n.tkey("lang_QRCode")}}:</span>
        </div>

        <div style="display: flex;flex-direction: column;">
          <el-image class="card-img" :src="imgUrl" >
            <template #error>
              <img class="card-img" :src="`${staticPath}mytextures/404_img.png`">
            </template>
          </el-image>
          <div>
            <el-text >{{proudctUrl}}</el-text>
            <el-button @click="copyShareUrl" class="icon-btn" type="info"><font-awesome-icon icon="fa-solid fa-copy" /></el-button>
          </div>
        </div>
      </div>




    </div>
</template>

<script setup>
import {inject, ref, onBeforeMount, onMounted, toRef, getCurrentInstance} from "vue";
    import myUtil from "@/util/util";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faCopy} from '@fortawesome/free-solid-svg-icons'
    import copy from "clipboard-copy";
    import {useUserinfo} from "@/stores/userinfo";
    import QRCode from "qrcode";

    library.add(faCopy)

    const userInfoRef = toRef(useUserinfo())
    const props = defineProps(['editObj','productObj'])
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const { proxy } = getCurrentInstance()
    const staticPath = process.env.BASE_URL
    const i18n = inject("i18n")
    const shopCompany = ref({})
    const imgUrl = ref("")
    const proudctUrl = ref("")
    const width = ref(250)
    const height = ref(250)

    function copyShareUrl(){
      if (null != proudctUrl.value){
        copy(proudctUrl.value)

          myUtil.alertSuccess(i18n.tkey("lang_copy_success"))
      }

    }

    function generateQRCode() {
      QRCode.toDataURL(
          proudctUrl.value,
          {
            errorCorrectionLevel: 'M' ,
            width: width.value,
            height: height.value,
            margin: 0,
            color: {
              dark: "#000000",
              light: "#ffffff"
            }
          },
          function (err, url) {
            imgUrl.value = url
          }
      )
    }

    onBeforeMount(() => {
      shopCompany.value = getShopCompanyObj()
    })

    onMounted(() => {
      var whereStr=""
      // if (myUtil.isNotEmpty(userInfoRef.value.login)){//
      //   whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
      // }
      if(myUtil.isNotEmpty(props.editObj)){
        proudctUrl.value = `${proxy.$SSL}://${props.productObj.procedurename}/Web/W006/single_product.asp?${whereStr}productID=${props.productObj.productid}&ProductCompanyCode=${props.productObj.acccode}&CompanyCode=${props.productObj.acccode}&PromoNo=${props.editObj.PromoNo}&formUrl=3dshop`

        generateQRCode()
      }
    })

</script>

<style scoped>
    .input-part {
        margin-bottom: 20px;
      width: 50%;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }
    .card-img{
      width: 100%;
      max-height: 400px;
    }

    @media screen and (min-width: 768px) {
      .card-img{
        width: 400px;
        height: 400px;
      }
    }
</style>